import React from 'react';
import { FiZap, FiWifi, FiMonitor, FiActivity } from 'react-icons/fi';
import './VideoCall.css';

const stats = [
  { icon: <FiZap />, label: 'Ultra Low Latency', value: '<100ms' },
  { icon: <FiWifi />, label: 'Adaptive Quality', value: 'Auto HD' },
  { icon: <FiMonitor />, label: 'Smooth FPS', value: '60fps' },
  { icon: <FiActivity />, label: 'Uptime', value: '99.9%' },
];

const VideoCall = () => {
  return (
    <section className="videocall" id="videocall">
      <div className="container">
        <div className="vc-grid">
          <div className="vc-visual">
            <div className="vc-card">
              <div className="vc-pulse"></div>
              <div className="vc-screen">
                <div className="vc-avatar-large"></div>
                <div className="vc-call-indicator">
                  <span className="vc-dot"></span>
                  <span>Live • HD</span>
                </div>
                <div className="vc-latency-badge">
                  <FiActivity size={12} />
                  <span>23ms</span>
                </div>
              </div>
              <div className="vc-mini-screen">
                <div className="vc-avatar-small"></div>
              </div>
            </div>
          </div>
          <div className="vc-content">
            <span className="section-tag vc-tag">⚡ Video Calling</span>
            <h2>Smooth & <span className="gradient-text">Low Latency</span> Video Calls</h2>
            <p className="vc-desc">
              Experience crystal-clear video calls with near-zero lag. Our WebRTC-powered 
              infrastructure ensures buttery smooth connections even on slower networks. 
              Adaptive bitrate automatically adjusts quality for the best experience.
            </p>
            <div className="vc-stats">
              {stats.map((s, i) => (
                <div className="vc-stat" key={i}>
                  <div className="vc-stat-icon">{s.icon}</div>
                  <div>
                    <strong>{s.value}</strong>
                    <span>{s.label}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="vc-features-list">
              <div className="vc-feature-item">✓ No buffering or freezing</div>
              <div className="vc-feature-item">✓ Works on 3G/4G/5G & WiFi</div>
              <div className="vc-feature-item">✓ Automatic reconnection</div>
              <div className="vc-feature-item">✓ Echo & noise cancellation</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoCall;
